import { render } from "./Partners.vue?vue&type=template&id=5b397ec4&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=5b397ec4&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b397ec4"]])

export default __exports__